<!--
  --
  -- パスワード設定 グループ
  --
  -->
<template>
  <c-form card-style
    v-model="valid"
    @submit="onSubmit"
  >
    <!-- Title -->
    <v-card-title>
      <slot name="title"/>
    </v-card-title>

    <!-- Contents -->
    <v-card-text>
      <slot/>

      <p>
        パスワードは6〜64文字です。<br>
        パスワードには、半角の英数字記号がご使用いただけます。<br>
        ご利用頂ける記号は、<code class="text--primary">!?#$%()+-*/=@;:,._&lt;&gt;[]{}</code> です。<br>
        パスワードは英大文字、小文字、数字、記号の内３種類以上の文字を入れてください
      </p>

      <v-text-field
        label="パスワード"
        prepend-icon="lock"
        type="password"
        v-model="form.password"
        :rules="[rule.required('パスワード'), rule.password]"
        @input="errors = []"
      />
      <v-text-field
        label="パスワード(確認)"
        prepend-icon="lock"
        type="password"
        v-model="form.confirm"
        :rules="[rule.required('パスワード(確認)'), rule.password]"
        @input="errors = []"
      />
    </v-card-text>

    <c-card-errors :errors="errors"/>

    <!-- Actions -->
    <v-card-actions>
      <v-spacer/>

      <v-btn
        color="primary" type="submit"
        :loading="running"
        :disabled="!valid || running"
      >
        <slot name="submit-text"/>
      </v-btn>
    </v-card-actions>
  </c-form>
</template>

<script>
import CForm from '@/components/CForm'
import CCardErrors from '@/components/CCardErrors'

export default {
  name: 'CPasswordGroup',
  components: {
    CForm,
    CCardErrors
  },
  data: () => ({
    // フォームデータ
    form: {
      password: '',
      confirm: ''
    },

    // フォームのバリデーション状態
    valid: true,

    // フォームのエラーメッセージ
    errors: [],

    // 処理中
    running: false
  }),
  methods: {
    /**
     * Submit ボタンが押された
     */
    onSubmit () {
      // エラー表示を消す
      this.errors = []

      // 入力値を確認する
      if (this.form.password !== this.form.confirm) {
        this.errors = [
          'パスワードが一致しません。'
        ]
        return
      }

      // パスワードが確認されたことを通知する
      this.running = true
      this.$emit('confirmed', this.form.password, errors => {
        this.running = false
        if (errors) {
          this.errors = errors
        }
      })
    }
  }
}
</script>
